const readMore = () => {
  const readMoreButton = document.querySelector('.read-more');
  const longText = document.querySelector('.long-text');

  if (readMoreButton && longText) {
    readMoreButton.addEventListener('click', function () {
      longText.classList.add('shown-text');
    });
  }

};

export {readMore};
